import { Injectable, TemplateRef  } from '@angular/core';
 
@Injectable({
  providedIn: 'root'
})
export class ToastService {
 
  toasts: any[] = [];
 
  // Push new Toasts to array with content and options
  show(textOrTpl: string | TemplateRef<any>, options: any = {}) {
    this.toasts.push({ textOrTpl, ...options });
  }

  success(textOrTpl: string | TemplateRef<any>) {
    var options = {
      classname: 'bg-success text-light',
      autohide: true,
      delay: 8000,
      headertext: 'Success'
    }
    this.toasts.push({ textOrTpl, ...options })
  }

  // error(textOrTpl: string | TemplateRef<any>) {
  //   var options = {
  //     classname: 'bg-danger text-light',
  //     autohide: true,
  //     delay: 8000,
  //     headertext: 'Error!'
  //   }
  //   this.toasts.push({ textOrTpl, ...options })
  // }


  info(textOrTpl: string | TemplateRef<any>) {
    var options = {
      classname: 'bg-info text-light',
      autohide: true,
      delay: 8000,
      headertext: 'Error!'
    }
    this.toasts.push({ textOrTpl, ...options });
  }

  // Callback method to remove Toast DOM element from view
  remove(toast) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }
}
